const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/components/EmptyState/translations.ts';
import { defineMessages } from '@cistec/common_web/utils/intlUtils';

declare const __RELATIVE_SOURCE_FILE__: string;

export default defineMessages(
    {
        unknownKind: 'Die Seite ist leer. Unbekannter Typ.',
        backToStartButton: 'Startseite',
    },
    __RELATIVE_SOURCE_FILE__
);
